import type { UseFormReturn } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { ComboboxField, type ComboboxOption } from '@/components/combobox-field';
import { RAISE_CURRENCIES, type RaiseFormValues } from '../lib/raise-form-schema';

type Ctrl = UseFormReturn<RaiseFormValues>['control'];

const CURRENCY_OPTIONS: ComboboxOption[] = RAISE_CURRENCIES.map((value) => ({
  value,
  label: value,
}));

// Target price with its currency, side by side like the launchpad drawer.
// FX has no currency selector: the rate's denomination is fixed by the pair
// (EUR/USD = 1.0850 USD per EUR), so a separate currency would be redundant.
export function TargetPriceFields({ control, isFx }: Readonly<{ control: Ctrl; isFx: boolean }>) {
  return (
    <div className={isFx ? undefined : 'grid grid-cols-[1fr_7rem] gap-2'}>
      <FormField
        control={control}
        name="targetPrice"
        render={({ field }) => (
          <FormItem>
            {/* For FX the target is an exchange rate, not a per-tonne price. */}
            <FormLabel>{isFx ? 'Target FX Rate' : 'Target Price'}</FormLabel>
            <FormControl>
              <Input
                inputMode="decimal"
                placeholder={isFx ? 'e.g. 1.0850' : 'Optional'}
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      {!isFx && (
        <ComboboxField<RaiseFormValues>
          name="targetPriceCurrency"
          label="Currency"
          options={CURRENCY_OPTIONS}
          searchable={false}
        />
      )}
    </div>
  );
}
